module.exports = __webpack_public_path__ + "img/ja.be04fd89.svg";